export default {
  scan_with_camera:
    "Scan with your phone camera to download the FoodAmigos App",
};
